// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { LocationSearchModel } from '~/misc/location/search/models/location-search.model';

// Types
import type { TSearchPerformer } from '~/misc/location/autocomplete/types';
import type { ILocationSearchResult } from '~/misc/location/search/types';
import { ESearchResultType } from '~/misc/location/search/types';

export class LocationSearchDataClient
  extends AbstractDataClient<LocationSearchModel>
  implements TSearchPerformer
{
  constructor(include: ESearchResultType[], endpoint?: string) {
    super(new LocationSearchModel(include, endpoint));
  }

  public searchByQuery(query: string): Promise<ILocationSearchResult[]> {
    return this.request('search', query);
  }
}
